import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './styles/styles.module.scss';
import CircleButton from '../../shared/CircleButton';
import proBadge from './pro-badge.svg';
import currLocIcon from '../../../../assets/images/icons/trail/icons-controls-nearby.svg';
import icon3d from '../../../../assets/images/icons/trail/icons-controls-3d.svg';
import iconCompass from '../../../../assets/images/icons/trail/icons-controls-compass.svg';
import icon2d from '../../../../assets/images/icons/trail/icons-controls-2d.svg';
import zoomInIcon from '../../../../assets/images/icons/trail/icons-controls-zoom-in.svg';
import zoomOutIcon from '../../../../assets/images/icons/trail/icons-controls-zoom-out.svg';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { wrapEventHandler } from '../../../utils/handlers';
import { LanguageSupportUtil } from '../../../utils/language_support_util';
import { EN_US } from '../../../utils/constants/LanguageRegionCode';

const ZoomControls = ({
  languageRegionCode,
  compassRotation,
  terrainDisabled,
  terrainActive,
  isPro,
  isAuthenticated,
  currentLayerTerrainEnabled,
  handleCompassClick,
  handleDisable3D,
  handleEnable3D,
  handleZoomInClick,
  handleZoomOutClick,
  handleCurrLocClick
}) => {
  const trackedTerrainClickHandler = () => {
    if (terrainActive) {
      handleDisable3D();
    } else {
      const stringifiedEventData = JSON.stringify({ pro: isPro });
      _gaq.push(['_trackEvent', 'Interactive Map', '3D Click', stringifiedEventData]);

      if (isPro) {
        handleEnable3D();
      } else {
        const path = `/pro${isAuthenticated ? '' : '/signup'}`;
        window.location = LanguageSupportUtil.wrapUrlSafe(path, languageRegionCode);
      }
    }
  };

  const renderTerrainToggle = () => {
    if (terrainDisabled || !currentLayerTerrainEnabled) {
      return null;
    }

    const icon = terrainActive ? icon2d : icon3d;
    const key = icon;
    const title = StringConstantsMixin.strings.SEARCH[terrainActive ? 'DISABLE_3D' : 'ENABLE_3D'];

    if (!isPro) {
      return (
        <div className={styles.threeDWithProBadge}>
          <img src={proBadge} className={styles.proBadge} alt="AllTrails Pro" />
          <CircleButton key={key} icon={icon} onClick={wrapEventHandler(trackedTerrainClickHandler)} title={title} />
        </div>
      );
    }

    return <CircleButton key={key} icon={icon} onClick={wrapEventHandler(trackedTerrainClickHandler)} title={title} />;
  };

  const renderCompass = () => {
    if (terrainDisabled) {
      return null;
    }

    return (
      <CircleButton
        icon={iconCompass}
        onClick={wrapEventHandler(handleCompassClick)}
        title={StringConstantsMixin.strings.SEARCH.RESET_NORTH_PITCH}
        rotation={compassRotation}
      />
    );
  };

  return (
    <>
      {renderTerrainToggle()}
      {renderCompass()}
      <CircleButton icon={zoomInIcon} onClick={wrapEventHandler(handleZoomInClick)} title={StringConstantsMixin.strings.SEARCH.ZOOM_IN} />
      <CircleButton icon={zoomOutIcon} onClick={wrapEventHandler(handleZoomOutClick)} title={StringConstantsMixin.strings.SEARCH.ZOOM_OUT} />
      <CircleButton icon={currLocIcon} onClick={wrapEventHandler(handleCurrLocClick)} title={StringConstantsMixin.strings.SEARCH.CURRENT_LOCATION} />
    </>
  );
};

ZoomControls.propTypes = {
  languageRegionCode: PropTypes.string,
  compassRotation: PropTypes.number,
  terrainDisabled: PropTypes.bool,
  terrainActive: PropTypes.bool,
  isAuthenticated: PropTypes.bool.isRequired,
  isPro: PropTypes.bool.isRequired,
  currentLayerTerrainEnabled: PropTypes.bool,
  handleCompassClick: PropTypes.func,
  handleDisable3D: PropTypes.func,
  handleEnable3D: PropTypes.func,
  handleZoomInClick: PropTypes.func.isRequired,
  handleZoomOutClick: PropTypes.func.isRequired,
  handleCurrLocClick: PropTypes.func.isRequired
};

ZoomControls.defaultProps = {
  languageRegionCode: EN_US,
  compassRotation: 0,
  terrainDisabled: false,
  terrainActive: false,
  currentLayerTerrainEnabled: false,
  handleCompassClick: () => {},
  handleDisable3D: () => {},
  handleEnable3D: () => {}
};

export default ZoomControls;
